<script lang="ts">
  import { CloseX } from '$components/Icons';
  import Search from '$components/Icons/Search.svelte';
  interface Props {
    placeholder?: string;
    disableSubmit?: boolean;
    disableInput?: boolean;
    clearOnSubmit?: boolean;
    onSubmit?: (query: string) => void;
    onInput?: (query: string) => void;
  }

  let {
    placeholder = 'Search...',
    disableSubmit = false,
    disableInput = false,
    clearOnSubmit = true,
    onSubmit,
    onInput
  }: Props = $props();

  let inputElement: HTMLInputElement | undefined = $state();
  let inputValue = $state('');

  function handleSubmit(event: Event) {
    event.preventDefault();
    const query = inputValue;
    if (!query || disableSubmit) return;
    onSubmit?.(query);
    if (clearOnSubmit) {
      inputValue = '';
    }
  }

  function handleInput(event: Event) {
    inputValue = (event.target as HTMLInputElement).value;
    onInput?.(inputValue);
  }

  function clearInput() {
    inputValue = '';
    inputElement?.focus();
    onInput?.('');
  }
</script>

<form class="search-form" onsubmit={handleSubmit}>
  <div class="search-input-wrapper">
    <div class="search-icon">
      <Search />
    </div>

    <input
      class="search-input"
      type="text"
      bind:this={inputElement}
      bind:value={inputValue}
      oninput={handleInput}
      disabled={disableInput}
      {placeholder}
    />

    {#if inputValue}
      <button type="button" class="clear-button" onclick={clearInput} aria-label="Clear search">
        <CloseX />
      </button>
    {/if}
  </div>
</form>

<style lang="scss">
  @import 'src/scss/variables';

  .search-form {
    width: 100%;
    margin: 0 auto;
  }

  .search-input-wrapper {
    position: relative;
    display: flex;
    align-items: center;
    background-color: $background-depth-1-color;
    border: 1px solid $border-depth-2-color;
    border-radius: 8px;
    transition: all 0.2s ease;
    &:focus-within {
      border-color: $border-depth-1-color;
      box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.1);
    }
  }

  .search-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 16px;
    margin: 9px;
    color: var(--twist-color-gray-60);
  }

  input {
    flex: 1;
    height: 48px;
    padding: 0;
    border: none;
    background: none;
    font-size: 16px;
    font-family: var(--font-family-primary);
    color: $text-default-color;
    outline: none;
    padding-right: 16px;

    /* Remove browser's default search input styling */
    &::-webkit-search-decoration,
    &::-webkit-search-cancel-button,
    &::-webkit-search-results-button,
    &::-webkit-search-results-decoration {
      display: none;
    }

    &::placeholder {
      color: $text-helper-color;
    }

    &:disabled {
      cursor: not-allowed;
      background: none;
    }
  }

  .clear-button {
    display: flex;
    align-items: center;
    justify-content: center;
    background: none;
    border: none;
    padding: 8px;
    margin-right: 8px;
    cursor: pointer;
    color: var(--twist-color-gray-60);
    transition: color 0.2s ease;

    &:hover {
      color: $text-default-color;
    }

    :global(svg) {
      width: 16px;
      height: 16px;
    }
  }
</style>
